"use client";
import { Skeleton } from "antd";
import "./SectionCardSkeleton.css";

type Props = { count?: number };

export default function SectionCardSkeleton({ count = 3 }: Props) {
  return (
    <div className="section-card-skeleton" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div className="section-card-skeleton__card" key={i}>
          <Skeleton.Button active block className="section-card-skeleton__img" />
        </div>
      ))}
    </div>
  );
}
